import React from "react";
import { RefreshCw } from "lucide-react";

export class ViewerErrorBoundary extends React.Component {
  state = { hasError: false, key: 0 };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("[ViewerErrorBoundary]", this.props.name || "viewer", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid={`viewer-error-${this.props.name || "panel"}`} className="rounded-xl border border-rose-500/30 bg-rose-500/[0.04] p-6 text-center">
          <p className="text-sm text-slate-300">Errore nel visualizzatore{this.props.name ? ` (${this.props.name})` : ""}.</p>
          <button
            data-testid={`viewer-reload-${this.props.name || "panel"}`}
            onClick={() => this.setState((s) => ({ hasError: false, key: s.key + 1 }))}
            className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-500 text-slate-900 text-sm font-semibold hover:bg-cyan-400"
          >
            <RefreshCw className="h-4 w-4" /> Ricarica visualizzatore
          </button>
        </div>
      );
    }
    return <React.Fragment key={this.state.key}>{this.props.children}</React.Fragment>;
  }
}
